import { CustomFieldModel } from '../../../api/models/custom-field-model';

export const GOOGLE_CUSTOM_FIELDS: Partial<CustomFieldModel>[] = [
  {
    fieldTitle: 'Cities',
    fieldKey: 'addresses.city',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Street Addresses',
    fieldKey: 'addresses.streetAddress',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Countries',
    fieldKey: 'addresses.country',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Genders',
    fieldKey: 'genders.formattedValue',
    fieldType: 'list',
  },
  {
    fieldTitle: 'Birth Dates',
    fieldKey: 'birthdays.date',
    fieldType: 'list',
  },
];
